import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import PropTypes from 'prop-types';
import { Box, Button, DialogActions, Stack, TextField } from '@mui/material';
import { ButtonContained } from 'shared/components/Button';

const ModalSkComment = ({open, handleClose, type,comment,setComment}) => {
  return (
    <div>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <DialogContent sx={{p: 0}}>
          <Box className='p-4 d-flex flex-column' gap={8}>
            <Stack className='d-flex flex-column'>
              <h2 >
                   {type}   Dokumen SK
              </h2>
              <p className='text-center mt-4 mb-2'>Masukan Komentar</p>
                    <TextField value={comment} onChange={(e)=>setComment(e.target.value)} />
            </Stack>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant='contained'
            size='small'
            style={{
              width: '100px',
              backgroundColor: '#F5F5F5',
              color: '#9F9F9F',
            }}
            onClick={handleClose}
          >
            BATAL
          </Button>

          <ButtonContained variant='contained' onClick={handleClose}>
            SIMPAN
          </ButtonContained>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalSkComment;

ModalSkComment.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  type: PropTypes.string,
  comment:PropTypes.string,
  setComment:PropTypes.func
 
};
